import md5 from 'js-md5'
import { isNull } from 'lodash-es';
import {getTime} from "ym-js-box";
import {useUserStore} from "@/store/module/user";
export const makeSign = function (object) {
    object.timestamp = getTime();

    const newObject = objectToArr(object)
    let signString = objectToString(newObject)
    signString = signString.slice(0, -1)
    const key = process.env.VUE_APP_HOME_SIGN_KEY;
    object.sign = md5(md5(signString + key) + key);
    return object
}

// 对象转数组，并排序
const objectToArr = function (object, addkey = '') {
    let arrs = {}
    for (let i in object) {
        if (typeof object[i] !== 'undefined') {
            let newkey = addkey + (addkey === '' ? i : '[' + i + ']')
            if (typeof object[i] !== 'object' || isNull(object[i])) {
                arrs[newkey] = object[i]
            } else {
                Object.assign(arrs, objectToArr(object[i], newkey));
            }
        }
    }
    let sortKey = Object.keys(arrs).sort()
    let newObj = {}// 创建一个新的对象，用于存放排好序的键值对

    // 此处不能使用for..in
    sortKey.forEach(function (val) {
        newObj[val] = arrs[val]// 向新创建的对象中按照排好的顺序依次增加键值对
    })
    return newObj
}

// 对象转字符串
function objectToString(object, str = '') {
    for (var i in object) {
        if (typeof object[i] !== 'object' || isNull(object[i])) {
            str += i + '=' + (isNull(object[i]) ? '' : object[i]) + '&'
        } else {
            str += objectToString(object[i])
        }
    }
    return str
}
/**
 * 判断单条或者多条权限
 * @param auth
 * @returns {boolean}
 */
export function authCheck(auth) {
    const userStore = useUserStore()
    if (!userStore.token){
        return false
    }
    if (userStore.authRule.length === 0) {
        userStore.loadAuthRule()
    }
    if(typeof auth == 'string') return Object.values(userStore.authRule).indexOf(auth) >= 0;
    let result = true;
    for (let i = 0; i < auth?.length; i++) {
        result = Object.values(userStore.authRule).indexOf(auth[i]) >= 0;
        if(!result){
            return false
        }
    }
    return result;
}

export function getUserInfo() {
    const userStore = useUserStore()
    if (userStore.userInfo.length === 0) {
        userStore.updateUserInfo()
    }
    return userStore.userInfo.length;
}
export function logout() {
    const userInfoStore = useUserStore()
    userInfoStore.$reset()
    localStorage.removeItem('user')
}
